module.exports = __webpack_public_path__ + "img/money-from-bracket.3f939c4d.svg";